window['templates#index'] = function () {
  $('.toggle_active').on('change', function () {
    const id = $(this).data('template-id')
    const value = $(this).is(':checked')
    $.post(`/templates/${id}/toggle_active/`, { active: value })
  })
}
